<template>
  <div>client_emails</div>
</template>

<script>
export default {
  name: "client_emails"
}
</script>

<style scoped>

</style>
